import {AfterContentChecked, AfterViewInit, Component} from '@angular/core';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewInit {
  constructor(private titleService: Title) {
    this.setTitle('بیمه درمان خانواده، مطمئن تر از مطمئن');
  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  ngAfterViewInit(): void {
  }

  loopThought() {
    const all = document.getElementsByTagName('*');

    for (let i = 0, max = all.length; i < max; i++) {
      // Do something with the element here
      if (!all[i].childElementCount) {
        all[i].innerHTML = this.toFarsiNumber(all[i].innerHTML);
      }
    }
  }

  toFarsiNumber(n) {
    const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

    return n
      .toString()
      .replace(/\d/g, x => farsiDigits[x]);
  }
}
